import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import routes, { formatRoute } from 'config/routes'
import { CurrencyContext } from 'contexts'
import { useBankrolls } from 'hooks'
import PropTypes from 'prop-types'
import React from 'react'
import { Button, ListGroup } from 'react-bootstrap'
import { FormattedDate, FormattedMessage, FormattedNumber } from 'react-intl'
import { Link } from 'react-router-dom'
import { confirm } from 'utils'

function Session(props) {
  const { actions, comments, onDelete, session } = props
  const currency = React.useContext(CurrencyContext)
  const { currentBankroll } = useBankrolls()
  const loss = session.earnings < 0
  const [hours, minutes] = session.duration.split(':').map(val => parseInt(val))
  const editSessionRoute = formatRoute(routes.sessionEdit, { id: session.id })

  const deleteSession = async () => {
    const msg = 'Are you sure you want to delete this session?'
    try {
      await confirm(msg)
      onDelete(session.id)
    } catch (err) {
      // no-op
    }
  }

  return (
    <ListGroup.Item className="session d-flex flex-column">
      <div className="d-flex flex-row justify-content-between">
        <div className="details d-flex flex-column">
          <h5 className="location">{session.location}</h5>
          <p className="date text-muted mb-1">
            <FontAwesomeIcon
              icon={['far', 'calendar-alt']}
              fixedWidth
              className="mr-1 text-success"
            />
            <FormattedDate
              value={session.date}
              day="numeric"
              month="short"
              year="numeric"
              timeZone="utc"
            />
          </p>
          <p className="duration text-muted mb-1">
            <FontAwesomeIcon
              icon={['far', 'clock']}
              fixedWidth
              className="mr-1 text-success"
            />
            <FormattedMessage
              id="sessionDuration"
              defaultMessage="{hours} {hours, plural, one {hour} other {hours}} {minutes} {minutes, plural, one {minute} other {minutes}}"
              values={{
                hours,
                minutes,
              }}
            />
          </p>
          {!currentBankroll.ev_disabled && (
            <p className="session-ev text-muted mb-1">
              <span className="mr-1 text-primary font-weight-bold">EV</span>
              <FontAwesomeIcon
                icon={currency.icon}
                className="mr-1 text-muted"
              />
              <FormattedNumber
                value={session.session_ev}
                minimumFractionDigits={2}
              />
            </p>
          )}
        </div>
        {comments && session.comments ? (
          <div className="comments align-self-center d-none d-md-flex flex-grow-1 mx-5">
            <FontAwesomeIcon
              icon={['far', 'comment-dots']}
              fixedWidth
              className="mr-1 text-success align-self-center"
            />
            <p className="mb-0">{session.comments}</p>
          </div>
        ) : null}
        <div className="d-flex flex-column justify-content-around">
          {actions ? (
            <div className="actions d-flex justify-content-end">
              <Button
                variant="warning"
                size="sm"
                as={Link}
                to={{
                  pathname: editSessionRoute,
                  state: {
                    session,
                  },
                }}
              >
                <FontAwesomeIcon icon={['far', 'pencil']} fixedWidth />
              </Button>
              {onDelete ? (
                <Button
                  variant="danger"
                  size="sm"
                  className="ml-1"
                  onClick={deleteSession}
                >
                  <FontAwesomeIcon icon={['far', 'trash']} fixedWidth />
                </Button>
              ) : null}
            </div>
          ) : null}
          <div className={`earnings${loss ? ' loss' : ''}`}>
            <sup>
              {loss ? <FontAwesomeIcon icon={['far', 'minus']} /> : null}
              <FontAwesomeIcon icon={currency.icon} fixedWidth />
            </sup>
            <FormattedNumber
              // eslint-disable-next-line
              style="decimal"
              minimumFractionDigits={2}
              maximumFractionDigits={2}
              value={Math.abs(session.earnings)}
            />
          </div>
        </div>
      </div>
      <div className="text-right">
        <a
          href={`https://members.blackjackapprenticeship.com?cat=170&s=${encodeURIComponent(
            session.location,
          )}&post_type=casino`}
          target="_blank"
          rel="noopener noreferrer"
        >
          Check Casino411
        </a>
      </div>
    </ListGroup.Item>
  )
}

Session.propTypes = {
  actions: PropTypes.bool.isRequired,
  comments: PropTypes.bool.isRequired,
  onDelete: PropTypes.func,
  session: PropTypes.object.isRequired,
}

Session.defaultProps = {
  actions: true,
  comments: true,
}

export default Session
